import store from '@/store'

export var cacheReport = {} //报表缓存数据

export const getCol = key => {
  const lastPath = location.href
    .split('/')
    .pop()
    .replace(/(union)?\?.*/g, '')
  //四率分析Th
  const fourpointlistUnionTh = [
    {
      title: '学校',
      dataIndex: 'className',
      key: 'className',
      width: 100,
      ellipsis: true
    },
    {
      title: '参考人数',
      dataIndex: 'studentNum',
      key: 'studentNum',
      width: 100,
      ellipsis: true
    }
  ]

  //学生成绩单
  const studenttranscriptlistUnionTh = [
    {
      title: '学校名称',
      dataIndex: 'stuOrgName',
      key: 'stuOrgName',
      fixed: true,
      width: 100
    },
    {
      title: '姓名',
      dataIndex: 'studentName',
      key: 'studentName',
      fixed: true,
      width: 100
    }
  ]

  //均分分析
  const getavgscorelistUnionTh = [
    {
      title: '学校',
      dataIndex: 'className',
      key: 'className',
      width: 100
    },
    {
      title: '平均分',
      dataIndex: 'AvgScore',
      key: 'AvgScore',
      width: 100
    },
    {
      title: 'B值',
      dataIndex: 'BValue',
      key: 'BValue',
      width: 100
    },
    {
      title: '联考排名',
      dataIndex: 'AvgRank',
      key: 'AvgRank',
      width: 100
    }
  ]

  //分数段分析
  const getscoreseglistUnionTh = [
    {
      title: '学校',
      dataIndex: 'ClassName',
      key: 'ClassName',
      width: 100,
      ellipsis: true
    },
    {
      title: '参考人数',
      dataIndex: 'StudentNum',
      key: 'StudentNum',
      width: 100,
      ellipsis: true
    }
  ]

  //位次段分析
  const getrankseglistUnionTh = [
    {
      title: '学校',
      dataIndex: 'ClassName',
      key: 'ClassName',
      width: 100,
      ellipsis: true
    },
    {
      title: '参考人数',
      dataIndex: 'StudentNum',
      key: 'StudentNum',
      width: 100,
      ellipsis: true
    }
  ]

  //试题得分表
  const subtopicScoreUnionTh = [
    {
      title: '学校',
      dataIndex: 'className',
      key: 'className',
      width: 160,
      ellipsis: true
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      width: 100,
      ellipsis: true
    },
    {
      title: '卷面分数',
      dataIndex: 'score',
      key: 'score',
      width: 80
    },
    {
      title: '班级排名',
      dataIndex: 'essClassOrder',
      key: 'essClassOrder',
      width: 100
    },
    {
      title: '年级排名',
      dataIndex: 'essGradeOrder',
      key: 'essGradeOrder',
      width: 100
    },
    {
      title: '联考排名',
      dataIndex: 'essAreaOrder',
      key: 'essAreaOrder',
      width: 100
    },
    {
      title: '客观题得分',
      dataIndex: 'objectScore',
      key: 'objectScore',
      width: 80
    },
    {
      title: '主观题得分',
      dataIndex: 'subjectScore',
      key: 'subjectScore',
      width: 80
    }
  ]

  const colData = {
    //四率分析
    getfourpointlistUnion: {
      singleReport: fourpointlistUnionTh,
      totalReport: fourpointlistUnionTh
    },
    //学生成绩单
    studenttranscriptlistUnion: {
      singleReport: studenttranscriptlistUnionTh,
      totalReport: studenttranscriptlistUnionTh
    },
    //均分分析
    getavgscorelistUnion: {
      singleReport: getavgscorelistUnionTh,
      totalReport: getavgscorelistUnionTh
    },
    //分数段分析
    getscoreseglistUnion: {
      singleReport: getscoreseglistUnionTh,
      totalReport: getscoreseglistUnionTh
    },
    //位次段分析
    getrankseglistUnion: {
      singleReport: getrankseglistUnionTh,
      totalReport: getrankseglistUnionTh
    },
    //试题得分表
    subtopicScoreUnion: {
      singleReport: subtopicScoreUnionTh,
      totalReport: subtopicScoreUnionTh
    }
  }
  const col = store.state.unionReport
    ? colData[key]
      ? colData[key][lastPath]
      : ''
    : ''
  return col
}

// 联考均分处理
export const getavgscorelistUnion = res => {
  res.data = res.data.map(item => {
    item.list = item.list.map(itemc => {
      itemc.classId = itemc.schoolId
      itemc.className = itemc.schoolName
      itemc.scoreList = itemc.scoreList.map(itemd => {
        let itemdObj = {}
        for (let d in itemd) {
          let key = d.slice(0, 1).toUpperCase() + d.slice(1)
          itemdObj[key] = itemd[d]
        }
        itemdObj.GradeAvgScore = itemdObj.ExamAvgScore
        return itemdObj
      })
      return itemc
    })
    return item
  })
  return res
}

// 四率分析处理
export const getfourpointlistUnion = res => {
  res.data.classInfoList = res.data.schoolList.map(item => {
    item.classId = item.schoolId
    item.className = item.schoolName
    return item
  })
  return res
}

//上线分析
export const getscorelineanalysisUnion = res => {
  res.data.lists = res.data.lists.map(item => {
    item.classInfoList = item.schoolList.map(itemc => {
      itemc.classId = itemc.schoolId
      itemc.className = itemc.schoolName
      return itemc
    })
    return item
  })
  return res
}

//学生成绩单接口
export const studenttranscriptlistUnion = res => {
  res.data.list = res.data.list.map(item => {
    item.stuOrgName = item.schoolName
    return item
  })
  return res
}
//学生成绩散点图
// export const studentScoreScatterPointUnion = res => {
//   console.log(res, '---res sdt---')
//   return res
// }

//分数段分析(联考)
export const getscoreseglistUnion = res => {
  res.data = res.data.map(item => {
    item.ClassName = item.SchoolName
    item.ClassID = item.SchoolId
    return item
  })
  return res
}

//位次段分析
export const getrankseglistUnion = res => {
  res.data = res.data.map(item => {
    item.ClassName = item.SchoolName
    item.ClassID = item.SchoolId
    return item
  })
  return res
}

//试题得分表
export const subtopicScoreUnion = res => {
  res.data = res.data.map(item => {
    item.className = item.schoolName
    return item
  })
  return res
}
